function warn(s) {
  console.warn('[react-ga]', s);
}

module.exports = warn;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-ga/src/utils/console/warn.js
 ** module id = 567
 ** module chunks = 1
 **/